var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyEsc02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#707590;}.cls-2{isolation:isolate;}.cls-3{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844343",
    "data-name": "Rectangle 844343",
    className: "cls-1",
    width: 51,
    height: 16,
    rx: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Esc",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22,12.42H17.23V3.85H22v.89H18.23V7.5h3.55v.88H18.23v3.15H22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.9,10.67a1.61,1.61,0,0,1-.67,1.38,3.15,3.15,0,0,1-1.87.49,4,4,0,0,1-2-.41v-.9a5.32,5.32,0,0,0,1,.37,4.08,4.08,0,0,0,1,.13,2.32,2.32,0,0,0,1.17-.24.79.79,0,0,0,.41-.74.78.78,0,0,0-.32-.64,5,5,0,0,0-1.27-.63,6.81,6.81,0,0,1-1.27-.59,1.7,1.7,0,0,1-.57-.56,1.5,1.5,0,0,1-.18-.76A1.45,1.45,0,0,1,24,6.33a3,3,0,0,1,1.75-.45,5.16,5.16,0,0,1,2,.42l-.35.79a4.76,4.76,0,0,0-1.75-.4,2,2,0,0,0-1,.22.65.65,0,0,0-.35.6.72.72,0,0,0,.13.44,1.38,1.38,0,0,0,.42.34A9.8,9.8,0,0,0,26,8.77a4,4,0,0,1,1.54.84A1.46,1.46,0,0,1,27.9,10.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.05,12.54a2.75,2.75,0,0,1-2.16-.86,3.56,3.56,0,0,1-.76-2.43,3.66,3.66,0,0,1,.77-2.49,2.8,2.8,0,0,1,2.22-.88A4.18,4.18,0,0,1,33,6a2.86,2.86,0,0,1,.73.23l-.3.83a3.8,3.8,0,0,0-.7-.21,3,3,0,0,0-.68-.09c-1.3,0-2,.83-2,2.5a2.93,2.93,0,0,0,.48,1.81,1.68,1.68,0,0,0,1.42.64,4.32,4.32,0,0,0,1.64-.35v.86A3.53,3.53,0,0,1,32.05,12.54Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyEsc02);
export default __webpack_public_path__ + "static/media/key_esc_02.df986e1d.svg";
export { ForwardRef as ReactComponent };